module.exports = __webpack_public_path__ + "img/scindex.82ec59b1.jpg";